import { CheckCircleFilled, ExclamationCircleFilled } from '@ant-design/icons';
import { notification } from 'antd';
import { OpenNotificationProps } from './types';
import React from 'react';

export const openNotification = ({
  message,
  description,
  type,
  duration = 5,
}: OpenNotificationProps) => {
  return notification[type]({
    message,
    description,
    duration,
    className: `message-${type}`,
    icon:
      type === 'success' ? <CheckCircleFilled /> : <ExclamationCircleFilled />,
  });
};
